module.exports = __webpack_public_path__ + "img/adicionar.b78567c0.svg";